var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{staticClass:"Logo",attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("../assets/logo-red.svg"),"alt":"Logo"}})]),_c('Result'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }